<template>
    <div>
        <h6 v-if="userEmail" class="mb-3">
            <small>
                {{ $t('project.settings.emails.userEmailAddress') }}
                <em>{{ userEmail }}</em>
            </small>
        </h6>
        <h6 v-else class="mb-3">
            <small>
                {{ $t('project.settings.emails.noUserEmailAddress') }}
            </small>
        </h6>
        <b-form novalidate v-if="emailSettings.sendEmailOnAssignedTasks != null">
            <b-form-group>
                <b-form-checkbox :disabled="!userEmail || !projectPermissions.includes('CHANGE_EMAIL_NOTIFICATION')" v-model="emailSettings.sendEmailOnAssignedTasks">
                    <span class="line-h-25" v-text="$t('project.settings.emails.assignedTasks')"></span>
                </b-form-checkbox>
            </b-form-group>
            <hr>
            <b-button type="button" class="btn-primary" @click="saveSettings()" :disabled="!projectPermissions.includes('CHANGE_EMAIL_NOTIFICATION') || !userEmail"  >{{ $t('project.settings.apply') }}</b-button>
        </b-form>
    </div>
</template>

<script>
import toastr from 'toastr';
import i18n from '@/i18n.bootstrap';
import projectsApi from '../../../api/projects';

export default {
    name: 'tab-emails',

    data() {
        return {
            projectId: this.$route.params.projectId,
            emailSettings: {
                sendEmailOnAssignedTasks: null
            }
        }
    },

    computed: {
        userEmail() {
            return this.$store.getters['userData/userData'].email;
        },
        projectPermissions() {
          if(this.$store.state.projects.currentProject.projectData.role){
            return this.$store.state.projects.currentProject.projectData.role.permissions;
          } else {
            return [];
          }
        },
    },

    mounted() {
        projectsApi.getEmailSettings(this.projectId)
            .then(res => {
                this.emailSettings.sendEmailOnAssignedTasks = this.userEmail ? res.data.sendEmailOnAssignedTasks : false;
            });
    },

    methods: {
        saveSettings() {
            projectsApi.setEmailSettings(this.projectId, this.emailSettings)
                .then(response => {
                    if(response) {
                        toastr.success(i18n.t('project.settings.emails.action.successUpdating'))
                    }
                })
                .catch(() => toastr.error(i18n.t('project.settings.emails.action.errorUpdating')));
        }
    }
}
</script>

<style>
.line-h-25 {
    line-height: 25px;
}
</style>
